import type { ApiResult, PaginatedApiResult, PaginationMeta } from './types'

export class BaseApiClient {
  protected baseUrl: string

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  protected async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`

    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      credentials: 'include',
    })

    const result = (await response.json()) as ApiResult<T>

    if (!response.ok || result.error) {
      throw new Error(result.error?.message || 'Erro desconhecido')
    }

    return result.data
  }

  protected async requestPaginated<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<{ data: T[]; meta: PaginationMeta }> {
    const url = `${this.baseUrl}${endpoint}`

    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      credentials: 'include',
    })

    const result = (await response.json()) as PaginatedApiResult<T>

    if (!response.ok || result.error) {
      throw new Error(result.error?.message || 'Erro desconhecido')
    }

    return { data: result.data, meta: result.meta }
  }
}
